export function forWho() {
  const buttons = document.querySelectorAll('.for-who-card .accordion__btn');

  buttons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const panel = btn.previousElementSibling;

      if (!panel || !panel.classList.contains('for-who-card__panel')) return;

      const isActive = btn.classList.contains('is-active');

      if (isActive) {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-expanded', 'false');
        panel.classList.remove('is-open');
      } else {
        btn.classList.add('is-active');
        btn.setAttribute('aria-expanded', 'true');
        panel.classList.add('is-open');
      }
    });
  });
}
